import { Footer } from "../styledComponents/styledComponents";

function FooterComp({ state }) {
  let valorTotal = state.reduce((prevValue, curValue) => {
    return prevValue + Number(curValue.price);
  }, 0);

  // if (valorTotal === 0) {
  //   valorTotal = "Carrinho Vazio";
  // }

  return (
    <>
      <Footer>
        <h4>Valor Total</h4>
        {/* <span>{valorTotal} </span> */}
        <span>
          {valorTotal
            ? new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(valorTotal)
            : "Carrinho Vazio"}
        </span>
      </Footer>
    </>
  );
}

export default FooterComp;
